import '../node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.constructor.mjs';
import '../node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.some.mjs';

const isLoginUserClient = cookies => {
  if (typeof window === 'undefined') {
    throw new Error('window 객체가 없습니다. 해당 함수는 반드시 client-side 에서 실행되어야 합니다.');
  }
  return cookies.split(';').some(value => {
    const trimmedValue = value.trim();
    return trimmedValue.startsWith('NID_SES=') || trimmedValue.startsWith('NID_AUT=');
  });
};
const isLoginUserServer = request => {
  if (typeof window !== 'undefined') {
    throw new Error('window 객체가 있습니다. 해당 함수는 반드시 server-side 에서 실행되어야 합니다.');
  }
  return typeof request.headers.nid_login_stat === 'string' && request.headers.nid_login_stat.startsWith('Success');
};

export { isLoginUserClient, isLoginUserServer };
